const Roles = {
  ADMIN: {
    id: 'admin',
    humanReadableName: 'Admin'
  },
  MANAGER: {
    id: 'manager',
    humanReadableName: 'Manager'
  },
  USER: {
    id: 'user',
    humanReadableName: 'User'
  },
  REPORTS_ONLY: {
    id: 'reports_only',
    humanReadableName: 'Reports Only'
  },
  STORE: {
    id: 'store',
    humanReadableName: 'Store'
  },
  STORE_ADMIN: {
    id: 'store_admin',
    humanReadableName: 'Store Admin'
  },
  SHIPPING: {
    id: 'shipping_only',
    humanReadableName: 'Shipper'
  }
}

export const findById = id => Object.keys(Roles).find(r => Roles[r].id === id)
export const humanReadableNameById = id => {
  try {
    return Roles[findById(id)].humanReadableName
  } catch (error) {
    return null
  }
}

export default Roles
